var util = {

	maandlast: function(leenbedrag, nominaal, looptijd)
	{
		return  util.annu(leenbedrag, (nominaal/100), looptijd);
	},

	annu: function(bedrag, rentevoet, periode)
	{
		waarde = (rentevoet / (1 - Math.pow((1+rentevoet), -periode))) * bedrag;
		return waarde;
	},

	nominaal: function(rente)
	{
		return (Math.pow((1 + rente / 100),(1 / 12)) - 1) * 100;
	},

	rente: function(product, leenbedrag, looptijd, maandlast, callback)
	{
		$.get("/ajax/rente_dnkm.php", {
			product: product,
			leenbedrag: leenbedrag,
			looptijd: looptijd ? Math.round(looptijd) : 0,
			maandlast: maandlast ? maandlast : 0,
			type: $('#productvorm').val()
		}, function(data){
			data = Math.round(Number(data.split(";")[1]) * 10) / 10;
			callback(data + 1);
		});
	},

	looptijd: function(leenbedrag, nominaal, maandlast)
	{
		var x = maandlast - (leenbedrag * (nominaal / 100));
		return Math.log(maandlast / x) / Math.log(1 + (nominaal / 100));
	},

	getMaandlast: function(woning, product, leenbedrag, looptijd, callback)
	{
		util.rente(product, leenbedrag, looptijd, undefined, function(rente){
			// if(woning != 1)
			// {
			// 	console.log(woning);
			// 	rente +=0.2;
			// }
			var nominaal = util.nominaal(rente);
			callback(util.maandlast(leenbedrag, nominaal, looptijd), rente);
		});
	},

	getRenteAndBedragOfNextBedrag: function(product, leenbedrag, looptijd, maandlast, callback)
	{
		$.get("/ajax/rente_dnkm.php", {
			product: product,
			leenbedrag: leenbedrag,
			looptijd: looptijd ? Math.round(looptijd) : 0,
			maandlast: maandlast ? maandlast : 0,
			getNextBedrag: true
		}, function(data){
			rente = Math.round(Number(data.split(";")[1]) * 10) / 10;
			bedrag = Number(data.split(";")[2]);
			callback(rente + 1, bedrag);
		});
	},

	/**
	 * Equals a string to a certain length, add html spaces (&nbsp;) till it reaches the same length as given
	 * @param {Object} string
	 * @param {Object} length
	 */
	equalString: function(string, length)
	{
		while(string.replace(/&nbsp;/g, 'x').length < length)
			string += '&nbsp;';
		return string;
	},

	/**
	 * Equals an array with string all the the given length
	 * @param {Object} obj
	 * @param {Object} length
	 */
	equalStrings: function (obj, length)
	{
		for(var id in obj)
			obj[id] = util.equalString(obj[id], length);
		return obj;
	},

	/**
	 * Converts an object to select options, the keys of the object are the value of the option
	 * The option where the value is the same as the given value will be selected
	 * @param {Object} obj
	 * @param {Object} value
	 */
	// objectToOptions: function(obj, value)
	// {
		// var html = '';
		// console.log(obj, value);
		// for(id in obj)
			// html += '<option '+(value == id ? 'selected="selected"' : '')+' value="'+id+'">' + obj[id] + '</option>';
		// console.log('z');
		// return html;
	// },

	objectToOptions: function(obj, value)
	{
		var array = [];
		for(var id in obj) {
			if(value == id)
				console.log("select", id, "because of", value);
			array.push('<option '+(value == id ? 'selected="selected"' : '')+' value="'+id+'">' + obj[id] + '</option>');
		}
		return array;
	},

	/**
	 * Returns the closest value to value in the aray
	 * @param {Object} value
	 * @param {Object} array
	 */
	closestValueInArray: function(value, array)
	{
		array.sort(function(a,b){return a-b;});
		console.log(array);
		for(var i = 0; i < array.length; i++)
		{
			if(value < array[i])
			{
				if(i === 0)
					return array[i];
				else if(array[i] - value >  value - array[i-1])
					return array[i-1];
				else
					return array[i];
			}
		}
		return array[array.length - 1];
	},

	/**
	 * Sorts an object based on its keys (this one is for numbers)
 	 * @param {Object} obj
	 */
	sortObject: function(obj, reverse){
	    var keys = [];
	    var sorted_obj = {};

	    for(var key in obj){
	        if(obj.hasOwnProperty(key)){
	            keys.push(key);
	        }
	    }



	    // sort keys
	    keys.sort(function(a,b){return Number(b)-Number(a);});

	    if(reverse) {
	    	keys.reverse();
	    }

		console.log('KEYS', keys);

	    // create new array based on Sorted Keys
	    jQuery.each(keys, function(i, key){
	        sorted_obj[key] = obj[key];
	    });

	    return sorted_obj;
	}

};

function ucfirst(string)
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}